<script setup lang="ts">
import type { BidProductPartner } from "mws-ts-v2-sdk";

defineProps<{ partner: BidProductPartner }>();
</script>

<template>
  <ProductSidebarUSP icon-key="partner">
    <template #title>
      {{
        partner.isMwsPartner
          ? $t("bidProductSidebar.partner.titleMwsPartner")
          : $t("bidProductSidebar.partner.title", {
              PLACEHOLDER_teamName: partner.name,
            })
      }}
    </template>

    <template #description>
      {{
        partner.isMwsPartner
          ? $t("bidProductSidebar.partner.descriptionMwsPartner")
          : $t("bidProductSidebar.partner.description", {
              PLACEHOLDER_teamName: partner.name,
            })
      }}
    </template>
  </ProductSidebarUSP>
</template>
